<div class="tema-movil min-h-screen bg-[var(--bg)]">
  <div class="text-white px-5 pt-6 pb-5" style="background: var(--sage)">
    <div class="flex items-start justify-between gap-3 mb-1">
      <div class="flex items-center gap-2.5">
        <span class="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm shrink-0"
              style="background: linear-gradient(140deg, var(--blue), var(--coral))">FC</span>
        <div>
          <div class="text-[15px] font-bold">Feria China 2026</div>
          <div class="text-[11px] text-[#AEB9CC]">{{ perfil()?.nombre }}</div>
          <app-indicador-version />
        </div>
      </div>
      <div class="shrink-0 flex items-center gap-2">
        <button
          type="button"
          (click)="verTablero()"
          class="text-[11.5px] font-semibold px-3 py-2 rounded-lg text-white"
          style="background: var(--blue)"
        >
          Ver tablero
        </button>
        <button
          type="button"
          (click)="cerrarSesion()"
          [disabled]="cerrandoSesion()"
          class="text-[11.5px] font-semibold px-3 py-2 rounded-lg border border-white/20 text-white/90 disabled:opacity-50"
        >
          {{ cerrandoSesion() ? 'Saliendo…' : 'Cerrar sesi&oacute;n' }}
        </button>
      </div>
    </div>
  </div>

  <div class="px-4 pt-4 pb-24">
    <div class="flex items-center justify-between mb-1">
      <span class="text-[11px] font-bold uppercase tracking-wide text-[var(--muted)]">Capturando como</span>
      <div class="flex gap-1.5">
        @for (letra of prefijos; track letra) {
          <button (click)="cambiarPrefijo(letra)"
                  [class]="prefijo() === letra
                    ? 'w-9 h-9 rounded-full text-[13px] font-bold bg-[var(--ink)] text-white'
                    : 'w-9 h-9 rounded-full text-[13px] font-bold bg-[var(--surface)] border border-[var(--border)] text-[var(--muted)]'">
            {{ letra }}
          </button>
        }
      </div>
    </div>
    <p class="text-[11px] text-[var(--faint)] mb-3">
      Cada persona que capture elige una letra distinta, as&iacute; sus c&oacute;digos de proveedor
      (<span class="font-mono">PROV-{{ prefijo() }}-001</span>, <span class="font-mono">PROV-{{ prefijo() }}-002</span>...) nunca chocan entre s&iacute;.
    </p>

    @if (pendientes() > 0) {
      <div class="bg-[var(--coral-soft)] text-[var(--coral-ink)] rounded-xl px-4 py-3 mb-4 text-[13px] font-semibold">
        <div class="flex items-center justify-between">
          <span>&uarr; {{ pendientes() }} foto(s)/ficha(s) en cola</span>
          <button (click)="sincronizar()" [disabled]="sincronizando() || !sesionSupabaseReal()"
                  class="bg-[var(--ink)] text-white text-[12px] font-bold px-3 py-2 rounded-lg disabled:opacity-50">
            {{ sincronizando() ? 'Sincronizando…' : 'Sincronizar' }}
          </button>
        </div>
        @if (!sesionSupabaseReal()) {
          <p class="mt-2 text-[11.5px] font-normal text-[var(--coral-ink)]">
            Inicia sesi&oacute;n con internet para sincronizar a Supabase.
          </p>
        }
        @if (errores().length > 0) {
          <button (click)="verErrores.set(!verErrores())" class="mt-2 text-[11.5px] underline">
            {{ verErrores() ? 'Ocultar' : 'Ver' }} por qu&eacute; no sincroniza ({{ errores().length }})
          </button>
          @if (verErrores()) {
            <div class="mt-2 bg-white/60 rounded-lg p-2.5 space-y-1.5">
              @for (e of errores(); track e) {
                <p class="text-[11px] font-mono break-words">{{ e }}</p>
              }
            </div>
          }
        }
      </div>
    }

    <button (click)="nuevoProveedor()"
            class="w-full text-[15px] font-bold py-4 rounded-xl text-white mb-4"
            style="background: var(--ink)">
      + Nuevo proveedor
    </button>

    <div class="space-y-2.5">
      @for (p of proveedores(); track p.codigo) {
        <div class="w-full bg-[var(--surface)] border-l-4 rounded-xl px-4 py-3 shadow-sm flex items-stretch gap-3" style="border-left-color: var(--blue)">
          <button (click)="continuarProveedor(p.codigo)" class="flex-1 text-left min-w-0">
            <span class="font-mono text-[10.5px] text-[var(--blue-ink)] bg-[var(--blue-soft)] px-2 py-0.5 rounded">{{ p.codigo }}</span>
            <div [class]="p.nombre ? 'text-[14.5px] font-bold mt-1' : 'text-[14.5px] font-bold mt-1 italic text-[var(--faint)]'">
              {{ p.nombre || '— sin nombre —' }}
            </div>
            <div class="text-[11.5px] text-[var(--muted)] mt-0.5">
              {{ p.sincronizado === 0 ? '· sin sincronizar' : '· sincronizado' }}
            </div>
          </button>
          <button
            type="button"
            (click)="abrirTarjetaRapida(p, $event)"
            title="Ver tarjeta del proveedor"
            aria-label="Ver tarjeta del proveedor"
            class="shrink-0 self-center text-[15px] leading-none px-1.5 py-2 text-[var(--faint)]"
          >
            🪪
          </button>
          <button
            type="button"
            (click)="abrirEdicionNombre(p, $event)"
            title="Editar nombre"
            aria-label="Editar nombre del proveedor"
            class="shrink-0 self-center text-[15px] leading-none px-1.5 py-2 text-[var(--faint)]"
          >
            ✏️
          </button>
          <button
            type="button"
            (click)="abrirBorradoProveedor(p, $event)"
            title="Eliminar proveedor"
            aria-label="Eliminar proveedor"
            class="shrink-0 self-center text-[15px] leading-none px-1.5 py-2 text-[var(--coral-ink)]"
          >
            🗑️
          </button>
          <button
            type="button"
            (click)="abrirDetalleProductos(p.codigo)"
            class="shrink-0 self-center text-[12px] font-bold px-3 py-2 rounded-lg bg-[var(--blue-soft)] text-[var(--blue-ink)]"
          >
            {{ conteos()[p.codigo] ?? 0 }} producto(s)
          </button>
        </div>
      }
      @if (proveedores().length === 0) {
        <p class="text-[13px] text-[var(--muted)] text-center py-6">
          Sin proveedores con prefijo {{ prefijo() }} todav&iacute;a.
        </p>
      }
    </div>

    <p class="text-[11px] text-[var(--faint)] mt-5 text-center">
      Tocar un proveedor = seguir captur&aacute;ndole productos. El prefijo evita choques de c&oacute;digos entre personas.
    </p>
  </div>

  @if (detalleAbierto()) {
    <div class="fixed inset-0 z-30 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-md bg-[var(--surface)] rounded-t-2xl sm:rounded-2xl border border-[var(--border)] shadow-xl max-h-[85vh] overflow-hidden flex flex-col">
        <div class="px-4 py-3 border-b border-[var(--border)] flex items-start justify-between gap-3">
          <div>
            <div class="text-[15px] font-bold">Productos de {{ detalleProveedorEtiqueta() }}</div>
            <div class="text-[11.5px] text-[var(--muted)]">{{ detalleProductos().length }} producto(s) guardados</div>
          </div>
          <button (click)="cerrarDetalleProductos()" class="text-[12px] font-semibold text-[var(--coral-ink)]">Cerrar</button>
        </div>
        <div class="px-4 py-3 border-b border-[var(--border)]">
          <app-tarjeta-proveedor [proveedor]="detalleProveedorObjeto()" />
        </div>
        <div class="p-4 overflow-y-auto space-y-2.5">
          @if (detalleProductos().length > 0) {
            @for (p of detalleProductos(); track p.id) {
              <div class="rounded-xl border border-[var(--border)] px-3.5 py-3 bg-[var(--surface)]">
                <div class="flex items-center justify-between gap-3">
                  <div class="min-w-0">
                    <div class="font-mono text-[11px] text-[var(--blue-ink)] truncate">{{ p.id }}</div>
                    <div [class]="p.mueble ? 'text-[13.5px] font-bold truncate' : 'text-[13.5px] font-bold truncate text-[var(--faint)]'">
                      {{ p.mueble || 'Nombre pendiente en dashboard' }}
                    </div>
                  </div>
                  <div class="text-[11px] font-semibold text-[var(--muted)] text-right">
                    {{ p.telas }} tela(s)<br />
                    {{ p.sincronizado ? 'Guardado online' : 'Guardado local' }}
                  </div>
                </div>
                @if (p.telasDetalle.length > 0) {
                  <div class="mt-2 border-t border-[var(--border)] pt-2 space-y-1">
                    @for (t of p.telasDetalle; track t.id) {
                      <div class="text-[11px] text-[var(--muted)]">
                        <span class="font-mono text-[var(--blue-ink)]">{{ t.muestrario || t.id }}</span>
                        {{ ' - ' }}{{ t.colores || 'Sin color' }}{{ ' - ' }}{{ t.tipo || 'Sin tipo' }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
          } @else {
            <p class="text-[13px] text-[var(--muted)]">No hay productos a&uacute;n para este proveedor.</p>
          }
        </div>
      </div>
    </div>
  }

  @if (tarjetaRapida(); as tp) {
    <div class="fixed inset-0 z-40 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-sm bg-[var(--surface)] rounded-2xl border border-[var(--border)] shadow-xl p-4">
        <div class="flex items-start justify-between gap-3 mb-3">
          <span class="font-mono text-[11px] text-[var(--blue-ink)]">{{ tp.codigo }}</span>
          <button (click)="cerrarTarjetaRapida()" class="text-[12px] font-semibold text-[var(--coral-ink)]">Cerrar</button>
        </div>
        <app-tarjeta-proveedor [proveedor]="tp" />
      </div>
    </div>
  }

  @if (editandoProveedor(); as ep) {
    <div class="fixed inset-0 z-40 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-sm bg-[var(--surface)] rounded-2xl border border-[var(--border)] shadow-xl p-4">
        <div class="font-mono text-[11px] text-[var(--blue-ink)] mb-2">{{ ep.codigo }}</div>
        <label for="editar-nombre-proveedor" class="block text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">
          Nombre del proveedor
        </label>
        <input
          id="editar-nombre-proveedor"
          [ngModel]="nombreEditado()"
          (ngModelChange)="nombreEditado.set($event)"
          placeholder="Nombre del proveedor"
          class="w-full border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] bg-[var(--surface)] mb-3"
        />
        <div class="flex items-center gap-2.5">
          <button type="button" (click)="cerrarEdicionNombre()" class="flex-1 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)]">
            Cancelar
          </button>
          <button
            type="button"
            (click)="guardarNombreEditado()"
            [disabled]="guardandoNombre()"
            class="flex-1 text-[13px] font-bold py-2.5 rounded-lg text-white"
            style="background: var(--ink)"
          >
            {{ guardandoNombre() ? 'Guardando…' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>
  }

  @if (borrandoProveedor(); as bp) {
    <div class="fixed inset-0 z-40 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-sm bg-[var(--surface)] rounded-2xl border border-[var(--border)] shadow-xl p-4">
        <div class="font-mono text-[11px] text-[var(--blue-ink)] mb-2">{{ bp.codigo }}</div>
        <p class="text-[13.5px] font-bold mb-1.5">
          &iquest;Eliminar {{ bp.nombre || bp.codigo }}?
        </p>
        <p class="text-[12px] text-[var(--muted)] mb-3">
          Esto tambi&eacute;n elimina TODOS sus productos y telas guardados ({{ conteos()[bp.codigo] ?? 0 }} producto(s)).
          No se puede deshacer.
        </p>
        <div class="flex items-center gap-2.5">
          <button type="button" (click)="cerrarBorradoProveedor()" class="flex-1 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)]">
            Cancelar
          </button>
          <button
            type="button"
            (click)="confirmarBorradoProveedor()"
            [disabled]="eliminando()"
            class="flex-1 text-[13px] font-bold py-2.5 rounded-lg text-white disabled:opacity-50"
            style="background: var(--coral-ink)"
          >
            {{ eliminando() ? 'Eliminando…' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
